/* React */
import React from 'react';
import { Switch } from 'antd';
/* Styles */
import { Container } from './styles';
import { useThemeApp } from '../../hooks/theme';
import { FaMoon, FaSun } from 'react-icons/fa';


const SwitchTheme: React.FC = () => {
  const { toggleThemeApp, isDark } = useThemeApp();

  function handleSwitch(checked: boolean) {
    console.log(`switch to ${checked}`);
    toggleThemeApp();
  }

  return (
    <Container>
      <Switch
        checkedChildren={<FaMoon />}
        unCheckedChildren={<FaSun />}
        onChange={handleSwitch}
        checked={isDark}
      />
    </Container>
  );
};

export default SwitchTheme;
